import { render, staticRenderFns } from "./UnBansSubscription.vue?vue&type=template&id=225afb6b"
import script from "./UnBansSubscription.vue?vue&type=script&lang=js"
export * from "./UnBansSubscription.vue?vue&type=script&lang=js"
import style0 from "./UnBansSubscription.vue?vue&type=style&index=0&id=225afb6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports